import React from 'react';

import clsx from 'classnames';
import PropTypes from 'prop-types';

import { combineClasses } from 'wanderu-css';
import { localize } from 'wanderu-i18n';

import SectionTitle from '../../SectionTitle/SectionTitle';
import Grid from '../Grid/Grid';
import GridItem from '../GridItem/GridItem';
import {
    ChatIcon,
    QuickIcon,
    TicketsIcon,
    LowestPriceIcon,
} from '../Icons';
import Typography from '../Typography/Typography';

// eslint-disable-next-line css-modules/no-unused-class
import styles from './ValueProps.scss';

function ValueProps(props) {
    const {
        className,
        classes: classesProp = {},
        component: Component = Grid,
        componentProps,
        t,
        titlePresent = true,
        variant = 'normal',
        ...otherProps
    } = props;

    const classes = combineClasses(styles, classesProp);

    const valueProps = [
        {
            description: t('lowestPricesExplanation'),
            Icon: LowestPriceIcon,
            title: t('lowestPrices'),
        },
        {
            description: t('bestTravelOptionsExplanation'),
            Icon: TicketsIcon,
            title: t('bestTravelOptions'),
        },
        {
            description: t('quickEasyBookingExplanation'),
            Icon: QuickIcon,
            title: t('quickEasyBooking'),
        },
        {
            description: t('fastCustomerSupportExplanation'),
            Icon: ChatIcon,
            title: t('fastCustomerSupport'),
        },
    ];

    return (
        <>
            {titlePresent && (
                <SectionTitle className={styles.sectionTitle}>{t('uvps-header')}</SectionTitle>
            )}
            <Component
                align="center"
                classes={{ root: styles.grid }}
                spacing={0}
                autoRows
                {...componentProps}
                {...otherProps}
            >
                {valueProps.map((valueProp, index) => {
                    return (
                        <GridItem
                            className={clsx(
                                {
                                    [classes[variant]]: variant !== 'normal',
                                },
                                className,
                            )}
                            classes={{ root: classes.gridItem }}
                            justify="start"
                            key={index}
                            md={3}
                            xs={12}
                        >
                            <valueProp.Icon
                                className={clsx(
                                    {
                                        [classes[variant]]: variant !== 'normal',
                                    },
                                    classes.icon,
                                )}
                                fontSize="large"
                            />
                            <span className={classes.textColumn}>
                                <Typography
                                    className={clsx(
                                        {
                                            [classes[variant]]: variant !== 'normal',
                                        },
                                        classes.textAlign,
                                        classes.title,
                                    )}
                                    variant="subtitle"
                                >
                                    {valueProp.title}
                                </Typography>
                                <Typography
                                    className={clsx(
                                        {
                                            [classes[variant]]: variant !== 'normal',
                                        },
                                        classes.textAlign,
                                        classes.description,
                                    )}
                                    variant="body2"
                                >
                                    {valueProp.description}
                                </Typography>
                            </span>
                        </GridItem>
                    );
                })}
            </Component>
        </>
    );
}

ValueProps.propTypes = {
    classes: PropTypes.object,
    className: PropTypes.string,
    component: PropTypes.elementType,
    componentProps: PropTypes.object,
    sectionTitle: PropTypes.string,
    t: PropTypes.func,
    titlePresent: PropTypes.bool,
    variant: PropTypes.oneOf(['normal', 'spacious']),
};

export { ValueProps };
export default localize(ValueProps, ['t'], 'baseApp');
